document.addEventListener('DOMContentLoaded', function () {
            var acctTab = document.querySelector('.acct-tab');
            var showAccTab = document.querySelector('.show-acc-tab');
            acctTab.addEventListener('mouseenter', function () {
                showAccTab.style.display = 'block';
            });
            acctTab.addEventListener('mouseleave', function () {
                showAccTab.style.display = 'none';
            });
            showAccTab.addEventListener('mouseleave', function () {
                showAccTab.style.display = 'none';
            });
            showAccTab.addEventListener('mouseenter', function () {
                showAccTab.style.display = 'block';
            });
        });

        document.addEventListener('DOMContentLoaded', function () {
            var accountLink = document.querySelector('.acct-tab');
            var accTab = document.querySelector('.show-acc-tab');
            var closeButton = document.querySelector('.close-acc-tab');
            if (window.innerWidth < 768) {
                accountLink.addEventListener('click', function (event) {
                    event.stopPropagation();
                    if (accTab.style.display === 'none' || accTab.style.display === '') {
                        accTab.style.display = 'block';
                    } else {
                        accTab.style.display = 'none';
                    }
                });
                closeButton.addEventListener('click', function (event) {
                    event.stopPropagation();
                    accTab.style.display = 'none';
                });
                document.body.addEventListener('click', function (event) {
                    if (accTab.style.display === 'block') {
                        if (!accTab.contains(event.target) && !accountLink.contains(event.target)) {
                            accTab.style.display = 'none';
                        }
                    }
                });
            }
        });
